<template>
  <div id="inventoryReport">
    <vs-prompt
      vs-title="Envanter Sayım Raporu"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-close="cancel"
      @vs-cancel="cancel"
      :vs-active.sync="opening"
      vs-accept-text="Kaydet"
      @vs-accept="submit"
    >
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-table noDataText="Tabloda Veri Yok" :data="differences">
            <template slot="header">
              <div class="flex items-center">
                <export-to-excel
                :printOnExcel="JSON.parse(JSON.stringify(excelDataComputed))"
                ></export-to-excel>
              </div>
            </template>

            <template slot="thead">
              <vs-th>#</vs-th>
              <vs-th style="width: 400px" sort-key="productName">Ürün</vs-th>
              <vs-th>Eski Stok</vs-th>
              <vs-th>Yeni Stok</vs-th>
            </template>

            <template slot-scope="{ data }">
              <tbody ref="tbody">
                <vs-tr
                  :data="tr"
                  :key="i"
                  v-for="(tr, i) in data"
                  :state="tr.stock > tr.newStock ? 'danger' : 'success'"
                >
                  <vs-td class="font-semibold truncate">{{
                    data.length - i
                  }}</vs-td>
                  <vs-td :title="tr.productName">{{ tr.productName }}</vs-td>
                  <vs-td>{{ tr.stock }}</vs-td>
                  <vs-td>{{ tr.newStock }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
          {{ inventoryList }}
        </div>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import exportToExcel from "../../exportToExcel/exportToExcel.vue";

export default {
  components: {
    exportToExcel,
  },
  props: {
    differences: {
      type: Array,
      required: true,
    },
    inventoryList: {
      type: Array,
      required: true,
    },
    displayInv: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    excelDataComputed() {
      
        return {
          filename:
            new Date().toLocaleDateString() +
            " stok sayim raporu.xlsx",
          table:[...this.inventoryList],
        };
     
    },
    opening: {
      get() {
        return this.displayInv;
      },
      set() {},
    },
  },
  methods: {
    cancel() {
      this.$emit("closePage");
    },
    submit() {
      this.$emit("closePage");
      localStorage.removeItem("inventoryReport");
    },
  },
};
</script>

<style lang="scss" scoped>
#inventoryReport {
  .con-vs-dialog .vs-dialog {
    max-height: 95%;
    width: 1000px !important;
    max-width: 90% !important;
  }
}
</style>
